import * as Models from "./rlAdmin.models";
import * as Utils from "./rlAdmin.utils";
import * as angular from "angular";
import * as moment from "moment";
import { DateLocaleService } from "../services/date-locale-service";
import { rlAdminConstsModule } from "./rlAdmin.consts";
import rlAdminServicesModule from "./rlAdmin.services";
import { CharDataGroupCharsFilter, MetaDataFilter, DisplayTextFilter } from "../filters/chardata-filter";
import { Formatter } from "../filters/formatter";
import { Offset } from "../filters/offset";
import { HtmlToPlain } from "../filters/html-to-plain";

export function RecordIDFilter() {
    return (input: string) => {
        if (Utils.IdBuilder.isEntityID(input)) {
            return Utils.IdBuilder.splitEntityID(input).recID.toString();
        }
        return "";
    };
}

export interface IFacetFilter {
    (facets: Models.IKeyValuePair<string, number>[]): { key: string; value: string; count: number }[];
}

export function FacetFilter(): IFacetFilter {
    return (facets: Models.IKeyValuePair<string, number>[]) => {
        return _.map(facets, (item) => {
            var parts = item.key.split("|");
            return {
                key: item.key,
                value: parts[0] + "	(" + item.value + ")",
                count: item.value
            };
        });
    };
}

export interface IBytesToSizeFilter {
    (bytes: number): string;
}

export function BytesToSizeFilter(): IBytesToSizeFilter {
    return (bytes: number) => {
        var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
        if (bytes === 0) {
            return "n/a";
        }
        var i = Math.floor(Math.floor(Math.log(bytes) / Math.log(1024)));
        if (i === 0) {
            return bytes + " " + sizes[i];
        }
        return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    };
}

export interface IExclusiveFilter {
    (value: number): string;
}

export function ExclusiveFilter(): IExclusiveFilter {
    return (value: number) => {
        if (value == null) {
            return "";
        } else if (value == 1) {
            return "exclusive";
        } else if (value === 0) {
            return "non-exclusive";
        }
    };
}

export interface IFirstFilter {
    (input: any[]): any;
}

export function FirstFilter(): IFirstFilter {
    return (input: any[]) => {
        return _.first(input);
    };
}


export interface ITakeFilter {
    (input: any[], count: number): any[];
}

export function TakeFilter(): ITakeFilter {
    return (input: any[], count: number) => {
        return _.take(input, count);
    };
}

export interface IWhereFilter {
    (input: any[], clause: any): any[];
}

export function WhereFilter(): IWhereFilter {
    return (input: any[], clause: any) => {
        return _.where(input, clause);
    };
}

export function CountFilter() {
    return (input: any[]) => {
        return input.length;
    };
}

export function NonEmpty() {
    return (input: any) => {
        return !!(input && Object.keys(input).length > 0);
    }
}

export function TempAmountTagLabelFilter() {
    return (input: Models.ICharDataCollection, params: { groupId: number; visibility: number; }) => {
        if (input == undefined || input.templateMetaData == undefined || input.templateMetaData.characteristicMetaDatas == undefined) {
            return [];
        }

        return _(input.templateMetaData.characteristicMetaDatas)
            .filter((cmd) => {
                return cmd.tagLabel == "entity_template" || cmd.tagLabel == "entity_status"
                    || cmd.tagLabel == "amount" || cmd.tagLabel == "description" || cmd.tagLabel == "comments" || cmd.tagLabel == "category";
            })
            .filter((cmd) => { return (cmd.groupID == params.groupId || params.groupId == -1); })
            .sortBy((cmd) => { return cmd.groupID; })
            .sortBy((cmd) => { return cmd.sequenceNumber; })
            .valueOf();
    }
}

export function CleanByRegexFilter() {
    return (input: string, regex: string) => {
        if (input == null) {
            return "";
        }
        return input.replace(new RegExp(regex, "g"), "");
    };
}

export function PasswordFilter() {
    return (input: string) => {
        var output = "";
        for (var i = 0; i < input.length; i++) {
            output += "*";
        }
        return output;
    };
}

export function CharValue() {
    return (input: Models.ICharDataCollection, key: string) => {
        if (input == null || input.charDatas == null) {
            return null;
        }

        var charDatas = input.charDatas[key];
        if (charDatas == null || charDatas.length == 0) {
            return null;
        }
        return charDatas[0].value;
    };
}

export function CurrencyNumberFilter() {
    return (input: string) => {
        var amountValue = input;
        if (_.isObject(Utils.JsonUtil.Parse(input, null))) {
            var moneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(input, {});
            amountValue = moneyValue.locAmt;
        }
        return parseFloat((amountValue || "").replace(/[^0-9\.-]/g, "")).toFixed(2);
    };
}

export function NumberFilter() {
    return (input: string) => {
        if (!_.isEmpty(input)) {
            var numberValue = input;
            return numberValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        }
    };
}

MoneyCheckAndParse.$inject = ["$filter"];
export function MoneyCheckAndParse($filter: ng.IFilterService) {
    return (input: string) => {
        try {
            //Is the string JSON?
            var moneyJSONPattern = /{\"locAmt\":/gim;

            var isMatch = moneyJSONPattern.test(input);

            if (isMatch) {
                var moneyValue: Models.ICharDataMoneyValue = JSON.parse(input);

                return $filter("money")(input);
            }
            else {
                return input;
            }
        }
        catch (e) {
            return input;
        }
    };
}

MoneyFilter.$inject = ["$filter"];
export function MoneyFilter($filter: ng.IFilterService) {
    return (input: string, options: { curType?: string; curSym?: string } = {}) => {
        var inputValue = input || "";
        var cleanNumbers = (numberIn: string) => parseFloat((numberIn || "").replace(/[^0-9\.-]/g, ""));
        if (_.isObject(Utils.JsonUtil.Parse(inputValue, null))) {
            var moneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(inputValue, {});
            if (options.curType == "div") {
                return $filter("currency")(cleanNumbers(moneyValue.divAmt), (moneyValue.divSym || options.curSym) + " ");
            } else {
                return $filter("currency")(cleanNumbers(moneyValue.locAmt), (moneyValue.locSym || options.curSym) + " ");
            }
        } else if (inputValue) {
            return $filter("currency")(cleanNumbers(inputValue.toString()), options.curSym);
        } else {
            return "";
        }
    };
}

export function GreaterThanFilter() {
    return (input: any, field: string, comparator: number) => {
        var newArray = [];
        if (input && input.length > 0) {
            for (var i = 0; i < input.length; i++) {
                var item = input[i];
                if (item[field] > comparator) {
                    newArray.push(item);
                }
            }
        }

        return newArray;
    }
}

export function FilenameFilter() {
    return (input: string) => {
        var fpIndex = (input || "").lastIndexOf("filepicker/");
        if (fpIndex >= 0) {
            var fpNameEndIndex = input.indexOf("_");
            if (fpNameEndIndex >= 0) {
                return input.substring(fpNameEndIndex + 1);
            }
            else {
                return input;
            }
        }
        else {
            var index = (input || "").lastIndexOf('/');
            if (index >= 0) {
                return input.substring(index + 1);
            }
            return input
        }
    };
}

export function PhoneFilter() {
    return (tel: string) => {
        if (!tel) { return ''; }

        var value = tel.toString().trim().replace(/^\+/, '');

        value = value.replace(/[-|\\(|\\)|.|\s|\+]/g, '');

        var country, city, number;
        // these other conditions aren't accurate enough for a lot of international calling
        switch (value.length) {
            case 10: // +1PPP####### -> C (PPP) ###-####
                country = 1;
                city = value.slice(0, 3);
                number = value.slice(3);
                break;

            //case 11: // +CPPP####### -> CCC (PP) ###-####
            //    country = value[0];
            //    city = value.slice(1, 4);
            //    number = value.slice(4);
            //    break;

            //case 12: // +CCCPP####### -> CCC (PP) ###-####
            //    country = value.slice(0, 3);
            //    city = value.slice(3, 5);
            //    number = value.slice(5);
            //    break;

            default:
                return tel;
        }

        if (country == 1) {
            country = "";
        } else {
            country = "+" + country;
        }

        number = number.slice(0, 3) + '-' + number.slice(3);

        return (country + " (" + city + ") " + number).trim();
    }
}


DateFilter.$inject = ["dateLocaleService"];
export function DateFilter(dateLocaleService: DateLocaleService) {
    return (date, format, timezone) => {
        if (angular.isUndefined(date)) {
            return "";
        }
        var dateMoment = moment(date);
        if (!_.isEmpty(date) && date[date.length - 1] == "Z") {
            dateMoment.utc();
        }
        if (date == "" || !dateMoment.isValid()) {
            return "";
        }
        dateMoment = dateLocaleService.localizeMoment(dateMoment);
        if (format == "" || format == null) {
            format = "L";
        }
        return dateMoment.format(format);
    };
}

DateLocal.$inject = ["$filter", "dateLocaleService"];
export function DateLocal($filter: ng.IFilterService, dateLocaleService: DateLocaleService) {

    var standardDateFilter = $filter("date");

    return (date, format, timezone) => {
        if (angular.isUndefined(date)) {
            return "";
        }
        var utcDate = moment.utc(date);
        if (date == "" || !utcDate.isValid()) {
            return "";
        }
        utcDate.local();
        utcDate = dateLocaleService.localizeMoment(utcDate);
        return utcDate.format(format);
    };
}

export function JoinFilter() {
    return (input: any[], delimiter: string) => {
        return (input || []).join(delimiter || ',');
    };
}

CharDataStringValue.$inject = ["$filter"];
export function CharDataStringValue($filter: ng.IFilterService) {
    return (input: string) => {
        if (_.isObject(Utils.JsonUtil.Parse(input, null))) {
            return $filter<(input: string) => string>("money")(input);
        }
        else {
            return input;
        }
    };
}

export function SolrLabelToHumanReadableFilter() {
    return (input: string) => {
        if (input.toLowerCase() == 'userlabel') {
            input = 'Contact';
        } else if (input.toLowerCase() == 'companylabel') {
            input = 'Company';
        }
        if (input.endsWith("_str") || input.endsWith("_strs") || input.endsWith("_date") || input.endsWith("_double")) {
            input = input.substring(0, input.lastIndexOf("_"));
        }
        return input.split("_").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
    };
}

LocalizeDatesInString.$inject = ["dateLocaleService"];
export function LocalizeDatesInString(dateLocaleService: DateLocaleService) {
    return (input: string) => {
        var dateRegex = /(\d{1,2}[\/\.\-]\d{1,2}[\/\.\-]\d{4})|(\d{4}[\/\.\-]\d{1,2}[\/\.\-]\d{1,2})/g;

        //Find and replace
        return input.replace(dateRegex, function (date) {
            var dateMoment = moment(date);
            if (!_.isEmpty(date) && date[date.length - 1] == "Z") {
                dateMoment.utc();
            }
            if (date == "" || !dateMoment.isValid()) {
                return "";
            }
            dateMoment = dateLocaleService.localizeMoment(dateMoment);
            return dateMoment.format("L");
        });
    }
}

export function ToLower() {
    return (input: string) => {
        if (input) {
            return input.toLowerCase();
        }
    };
}

var rlAdminFiltersModule = angular.module("rlAdminFilters", [rlAdminConstsModule.name, rlAdminServicesModule.name]);
rlAdminFiltersModule
    .filter("recordID", RecordIDFilter)
    .filter("facetFilter", FacetFilter)
    .filter("bytesToSize", BytesToSizeFilter)
    .filter("exclusive", ExclusiveFilter)
    .filter("first", FirstFilter)
    .filter("take", TakeFilter)
    .filter("where", WhereFilter)
    .filter("count", CountFilter)
    .filter("cleanByRegex", CleanByRegexFilter)
    .filter("password", PasswordFilter)
    .filter("charValue", CharValue)
    .filter('greaterThan', GreaterThanFilter)
    .filter("currencyNumber", CurrencyNumberFilter)
    .filter("number", NumberFilter)
    .filter("filename", FilenameFilter)
    .filter("date", DateFilter)
    .filter("dateLocal", DateLocal)
    .filter("tempAmountTagLabelFilter", TempAmountTagLabelFilter)
    .filter("join", JoinFilter)
    .filter("tel", PhoneFilter)
    .filter("nonEmpty", NonEmpty)
    .filter("moneyCheck", MoneyCheckAndParse)
    .filter("money", MoneyFilter)
    .filter("charDataStringValue", CharDataStringValue)
    .filter("charDataGroupChars", CharDataGroupCharsFilter)
    .filter("metaData", MetaDataFilter)
    .filter("displayText", DisplayTextFilter)
    .filter("rlFormatter", Formatter)
    .filter("rlOffset", Offset)
    .filter("htmlToPlain", HtmlToPlain)
    .filter("solrLabelToHumanLabel", SolrLabelToHumanReadableFilter)
    .filter("localizeDatesInString", LocalizeDatesInString)
    .filter("toLower", ToLower);

export { rlAdminFiltersModule }